module.exports = __webpack_public_path__ + "img/p3.40223f9c.png";